import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import { firebaseConnect } from 'react-redux-firebase'
import filter from 'lodash/filter';
import * as folioActions from '../../actions/folio-actions';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import SimpleSpinner from '../../components/SimpleSpinner/SimpleSpinner';
import styled from 'styled-components';
import smoothScroll from '../../utility/smoothScroll';
import { Text } from '../../components/Text/Text';

import PropTypes from 'prop-types';

import '../../styles.scss';

const Content = styled.div`
      margin-top: 100px;
      
      @media (max-width: 640px) {
        margin-top: 50px;
      }
    `;

const Sidebar = styled.div`
  @media (max-width: 480px ) {
    img {
      width: 50%;
    }
  }
`;

const Story = styled.div`
  color: #ffe1bf;
  padding: 20px;

  h1, h2, h3, h5, h6, p {
    color: #ffe1bf;
  }
  
  a { color: #e02226; font-weight: bold; }
`;

const StoryWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  
  @media (max-width: 640px) {
    flex-wrap: wrap;
  }
`;


class OtherContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      crew: 0,
      showExtended: false
    };
  }

  handleClick = () => {
    this.setState(() => ({ showExtended: false }), () => {
      smoothScroll.scrollTo('storyTop');
    })
  };

  handleShowMore = () => { this.setState(() => ({ showExtended: !this.state.showExtended }))};

  render() {
    const isMobile = (/Mobi/.test(navigator.userAgent));
    const allStories = this.props.stories
        && filter(this.props.stories, { section: 'other'}) || [];

    const selectedStory = allStories
        && filter(allStories, { path: this.props.location.pathname.substr(1) })[0] || [];
    const sidebarPhotos = selectedStory && selectedStory.media && filter(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('sidebar'));
    const heroPhotos = selectedStory && selectedStory.media && filter(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('hero'));
    const backgroundImage = find(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('background') );
    const iconImage = find(selectedStory.media, (item) => item && item.tag && item.tag.toLowerCase().includes('icon') );

    const transitionProperties = {
      transitionName: "fadein",
      transitionAppear: true,
      transitionAppearTimeout: 3000,
      transitionEnterTimeout: 3000,
      transitionLeaveTimeout: 3000,
      transitionEnter: true,
      transitionLeave: true,
      key: 1
    };


    return (
        <Content className={ `story--${selectedStory.path}` }>
          { allStories.length > 0 ?
              <StoryWrapper bgImage={ backgroundImage && backgroundImage.url }>
                { sidebarPhotos && sidebarPhotos.length > 0 && <Sidebar><img src={ sidebarPhotos[0] && sidebarPhotos[0].url} /></Sidebar> }
                { heroPhotos && heroPhotos.length > 0 && heroPhotos.map((hero) => <div><img alt="" src={ hero.url } width="100%" height="auto" /></div>) }
                <Story>
                  <Text color="secondary" size="large" key="story-title" content={ selectedStory.title } />
                  <Text color="secondary" size="small" key="story-body" content={ selectedStory.body } />
                </Story>
              </StoryWrapper> : <SimpleSpinner /> }
        </Content> );
  }
}

OtherContainer.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['stories', 'sections']),
    connect(
        (state) => ({
          inside: state.inside,
          stories: state.firebase.data.stories,
          sections: state.firebase.data.sections,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(OtherContainer)



// WEBPACK FOOTER //
// ./src/containers/other/index.js